import { render, staticRenderFns } from "./CardBoxShow.vue?vue&type=template&id=8a5b2bc0&"
import script from "./CardBoxShow.vue?vue&type=script&lang=js&"
export * from "./CardBoxShow.vue?vue&type=script&lang=js&"
import style0 from "./CardBoxShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports